import ReportingService from "../../service/reporting-service";
import { cleanEmpty } from "../../helper/sb-fixer";
import { ReportingDefaults } from "../../constant/analytics-mapper";
import { ComponentNames } from "../../constant/component-constant";
import { logError, logAdapterEvent } from "../../helper/logger";
import { pickChannels } from "../../helper/channels-service-helpers";

const ADAPTER_NAME = "rsnLookupToolAdapter";

interface IRsnLookupToolAdapter {
  content: any;
  componentId: string;
  index: number;
  queryParams: any;
  channelListingData: any;
  channelsServiceData?: any;
  genreLocalChannelMapping: any;
  cmsPageName?: string;
}

export const rsnLookupToolAdapter = ({
  content: contentArg,
  componentId,
  index,
  queryParams,
  channelListingData,
  channelsServiceData,
  genreLocalChannelMapping,
  cmsPageName
}: IRsnLookupToolAdapter): any => {
  let content = contentArg;
  try {
    logAdapterEvent(ADAPTER_NAME, "starting rsn lookup tool adaption", {
      cmsPageName,
      componentId,
      index
    });
    const nationalChannels = [];
    if (content?.variant === "nationalAndRsn") {
      const sourceChannels =
        pickChannels(
          channelsServiceData?.channels,
          channelListingData?.[":items"]?.chnlListingPageData?.elements?.channels
        );
      sourceChannels?.forEach(channel => {
        channel?.packageListSystem?.forEach(packageId => {
          if (packageId === "ATT_TV_MYHOMETEAM") {
            nationalChannels.push(channel);
          }
        });
      });
    }

    content = cleanEmpty(content);

    const data = new ReportingService().fixAnalyticsValues(
      content,
      ReportingDefaults.RsnLookupTool,
      ComponentNames.RSNLOOKUPTOOL,
      index
    );
    return {
      props: {
        ...data,
        options: {
          id: componentId
        },
        nationalChannels,
        queryParams,
        genreLocalChannelMapping
      },
      type: ComponentNames.RSNLOOKUPTOOL
    };
  } catch (error) {
    logError(ADAPTER_NAME, error, {
      cmsPageName,
      componentId,
      index
    });
  }
};

export interface IDynamicRsnLookupToolAdapter {
  channelListingData: any;
  channelsServiceData?: any;
  componentProps;
  queryParams: any;
}

export function dynamicRsnLookupToolAdapter({
  channelListingData,
  channelsServiceData,
  queryParams,
  componentProps
}: IDynamicRsnLookupToolAdapter) {
  try {
    logAdapterEvent(ADAPTER_NAME, "starting dynamic rsn lookup tool adaption", {
      queryParams
    });
    const nationalChannels = [];
    if (
      componentProps?.variant === "nationalAndRsn" &&
      !(queryParams?.showchannels && queryParams?.showchannels === "rsn")
    ) {
      const sourceChannels =
        pickChannels(
          channelsServiceData?.channels,
          channelListingData?.[":items"]?.chnlListingPageData?.elements?.channels
        );
      sourceChannels?.forEach(channel => {
        channel.packageListSystem?.forEach(packageId => {
          if (packageId === "ATT_TV_MYHOMETEAM") {
            nationalChannels.push(channel);
          }
        });
      });
    }

    return {
      ...componentProps,
      queryParams,
      nationalChannels
    };
  } catch (error) {
    logError(ADAPTER_NAME, error, { queryParams });
    return componentProps;
  }
}
